export const translations = {
  en: {
    // Navigation
    home: "Home",
    dashboard: "Dashboard",
    properties: "Properties",
    services: "Services",
    messages: "Messages",
    settings: "Settings",
    admin: "Admin",
    logout: "Logout",
    
    // Auth
    login: "Login",
    register: "Register",
    email: "Email",
    password: "Password",
    name: "Name",
    phone: "Phone",
    confirmPassword: "Confirm Password",
    forgotPassword: "Forgot Password?",
    noAccount: "Don't have an account?",
    hasAccount: "Already have an account?",
    loginSuccess: "Welcome back!",
    registerSuccess: "Account created successfully!",
    loginError: "Invalid credentials",
    registerError: "Registration failed",
    
    // Roles
    owner: "Property Owner",
    admin_role: "Administrator",
    
    // Landing Page
    heroTitle: "Your property in good hands",
    heroSubtitle: "Professional concierge services for property owners away from home",
    security: "Security",
    trust: "Trust",
    availability: "Availability",
    serenity: "Serenity",
    getStarted: "Get Started",
    learnMore: "Learn More",
    ourServices: "Our Services",
    aboutUs: "About Us",
    contactUs: "Contact Us",
    
    // Dashboard
    welcome: "Welcome",
    yourProperties: "Your Properties",
    upcomingServices: "Upcoming Services",
    recentMessages: "Recent Messages",
    quickActions: "Quick Actions",
    addProperty: "Add Property",
    bookService: "Book Service",
    viewAll: "View All",
    noProperties: "No properties yet",
    noServices: "No scheduled services",
    noMessages: "No messages",
    remainingHours: "Remaining Hours",
    
    // Properties
    propertyName: "Property Name",
    address: "Address",
    description: "Description",
    propertyType: "Property Type",
    house: "House",
    apartment: "Apartment",
    villa: "Villa",
    bedrooms: "Bedrooms",
    bathrooms: "Bathrooms",
    status: "Status",
    active: "Active",
    inactive: "Inactive",
    pending: "Pending",
    createProperty: "Create Property",
    editProperty: "Edit Property",
    deleteProperty: "Delete Property",
    propertyCreated: "Property created successfully",
    propertyUpdated: "Property updated successfully",
    propertyDeleted: "Property deleted successfully",
    propertyExists: "Property with this name or address already exists",
    propertyPhotos: "Property Photos",
    allowedFormats: "Allowed formats: JPG, JPEG, PNG (max 5MB)",
    
    // Services
    serviceType: "Service Type",
    cleaning: "Cleaning / Interior Maintenance",
    garden: "Garden Maintenance",
    repairs: "Small Repairs & DIY",
    maintenance: "Property Maintenance",
    rental_prep: "Rental Preparation",
    urgent: "Urgent Intervention",
    selectProperty: "Select Property",
    selectDate: "Select Date",
    selectTime: "Select Time Slot",
    morning: "Morning (8:00 - 12:00)",
    afternoon: "Afternoon (12:00 - 17:00)",
    evening: "Evening (17:00 - 20:00)",
    accepted: "Accepted",
    completed: "Completed",
    cancelled: "Cancelled",
    bookServiceTitle: "Book a Service",
    serviceCreated: "Service booked successfully",
    serviceUpdated: "Service updated successfully",
    serviceCancelled: "Service cancelled",
    minHours: "Minimum hours",
    perHour: "per hour",
    productsIncluded: "All products and accessories supplied",
    
    // Packages
    packages: "Packages",
    singleService: "Single Service",
    pack10: "10 Hours Package",
    pack20: "20 Hours Package",
    recurringPackage: "Weekly/Monthly Recurring",
    hoursPackage: "hours",
    weeksMinimum: "weeks minimum",
    perWeek: "per week",
    buyPackage: "Buy Package",
    payByCard: "Pay by Card",
    payByTransfer: "Pay by Transfer",
    paymentSuccess: "Payment successful!",
    paymentPending: "Payment pending...",
    
    // Urgent
    urgentCall: "Urgent Call",
    urgentPhone: "06 42 52 68 27",
    urgentPrice: "35€/hour (min 2 hours)",
    urgentDescription: "For emergencies requiring immediate intervention",
    
    // Messages
    sendMessage: "Send Message",
    typeMessage: "Type your message...",
    messageSent: "Message sent",
    noConversations: "No conversations yet",
    startConversation: "Start a conversation",
    
    // Settings
    language: "Language",
    english: "English",
    french: "French",
    profile: "Profile",
    updateProfile: "Update Profile",
    profileUpdated: "Profile updated",
    
    // Admin
    allUsers: "All Users",
    allProperties: "All Properties",
    allServices: "All Services",
    totalUsers: "Total Users",
    totalProperties: "Total Properties",
    totalServices: "Total Services",
    pendingServices: "Pending Services",
    updateStatus: "Update Status",
    editContent: "Edit Content",
    
    // Common
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    view: "View",
    search: "Search",
    filter: "Filter",
    loading: "Loading...",
    error: "Error",
    success: "Success",
    confirm: "Confirm",
    back: "Back",
    next: "Next",
    submit: "Submit",
    selectOption: "Select an option",
    required: "Required",
    euros: "€",
  },
  fr: {
    // Navigation
    home: "Accueil",
    dashboard: "Tableau de bord",
    properties: "Propriétés",
    services: "Services",
    messages: "Messages",
    settings: "Paramètres",
    admin: "Administration",
    logout: "Déconnexion",
    
    // Auth
    login: "Connexion",
    register: "Inscription",
    email: "Email",
    password: "Mot de passe",
    name: "Nom",
    phone: "Téléphone",
    confirmPassword: "Confirmer le mot de passe",
    forgotPassword: "Mot de passe oublié ?",
    noAccount: "Pas de compte ?",
    hasAccount: "Déjà un compte ?",
    loginSuccess: "Bon retour !",
    registerSuccess: "Compte créé avec succès !",
    loginError: "Identifiants invalides",
    registerError: "Échec de l'inscription",
    
    // Roles
    owner: "Propriétaire",
    admin_role: "Administrateur",
    
    // Landing Page
    heroTitle: "Votre propriété entre de bonnes mains",
    heroSubtitle: "Services de conciergerie professionnels pour les propriétaires absents",
    security: "Sécurité",
    trust: "Confiance",
    availability: "Disponibilité",
    serenity: "Sérénité",
    getStarted: "Commencer",
    learnMore: "En savoir plus",
    ourServices: "Nos Services",
    aboutUs: "À Propos",
    contactUs: "Contact",
    
    // Dashboard
    welcome: "Bienvenue",
    yourProperties: "Vos Propriétés",
    upcomingServices: "Services à venir",
    recentMessages: "Messages récents",
    quickActions: "Actions rapides",
    addProperty: "Ajouter une propriété",
    bookService: "Réserver un service",
    viewAll: "Voir tout",
    noProperties: "Aucune propriété",
    noServices: "Aucun service programmé",
    noMessages: "Aucun message",
    remainingHours: "Heures restantes",
    
    // Properties
    propertyName: "Nom de la propriété",
    address: "Adresse",
    description: "Description",
    propertyType: "Type de propriété",
    house: "Maison",
    apartment: "Appartement",
    villa: "Villa",
    bedrooms: "Chambres",
    bathrooms: "Salles de bain",
    status: "Statut",
    active: "Actif",
    inactive: "Inactif",
    pending: "En attente",
    createProperty: "Créer une propriété",
    editProperty: "Modifier la propriété",
    deleteProperty: "Supprimer la propriété",
    propertyCreated: "Propriété créée avec succès",
    propertyUpdated: "Propriété mise à jour",
    propertyDeleted: "Propriété supprimée",
    propertyExists: "Une propriété avec ce nom ou cette adresse existe déjà",
    propertyPhotos: "Photos de la propriété",
    allowedFormats: "Formats acceptés: JPG, JPEG, PNG (max 5Mo)",
    
    // Services
    serviceType: "Type de service",
    cleaning: "Ménage / Entretien intérieur",
    garden: "Entretien Jardin",
    repairs: "Petites Réparations & Bricolage",
    maintenance: "Entretien de Propriété",
    rental_prep: "Préparation Locative",
    urgent: "Intervention Urgente",
    selectProperty: "Sélectionner une propriété",
    selectDate: "Sélectionner une date",
    selectTime: "Sélectionner un créneau",
    morning: "Matin (8h00 - 12h00)",
    afternoon: "Après-midi (12h00 - 17h00)",
    evening: "Soir (17h00 - 20h00)",
    accepted: "Accepté",
    completed: "Terminé",
    cancelled: "Annulé",
    bookServiceTitle: "Réserver un service",
    serviceCreated: "Service réservé avec succès",
    serviceUpdated: "Service mis à jour",
    serviceCancelled: "Service annulé",
    minHours: "Heures minimum",
    perHour: "par heure",
    productsIncluded: "Tous produits et accessoires fournis",
    
    // Packages
    packages: "Forfaits",
    singleService: "Service Unique",
    pack10: "Forfait 10 Heures",
    pack20: "Forfait 20 Heures",
    recurringPackage: "Récurrent Hebdo/Mensuel",
    hoursPackage: "heures",
    weeksMinimum: "semaines minimum",
    perWeek: "par semaine",
    buyPackage: "Acheter le forfait",
    payByCard: "Payer par Carte",
    payByTransfer: "Payer par Virement",
    paymentSuccess: "Paiement réussi !",
    paymentPending: "Paiement en cours...",
    
    // Urgent
    urgentCall: "Appel Urgent",
    urgentPhone: "06 42 52 68 27",
    urgentPrice: "35€/heure (min 2 heures)",
    urgentDescription: "Pour les urgences nécessitant une intervention immédiate",
    
    // Messages
    sendMessage: "Envoyer un message",
    typeMessage: "Tapez votre message...",
    messageSent: "Message envoyé",
    noConversations: "Aucune conversation",
    startConversation: "Démarrer une conversation",
    
    // Settings
    language: "Langue",
    english: "Anglais",
    french: "Français",
    profile: "Profil",
    updateProfile: "Mettre à jour le profil",
    profileUpdated: "Profil mis à jour",
    
    // Admin
    allUsers: "Tous les utilisateurs",
    allProperties: "Toutes les propriétés",
    allServices: "Tous les services",
    totalUsers: "Total utilisateurs",
    totalProperties: "Total propriétés",
    totalServices: "Total services",
    pendingServices: "Services en attente",
    updateStatus: "Mettre à jour le statut",
    editContent: "Modifier le contenu",
    
    // Common
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    edit: "Modifier",
    view: "Voir",
    search: "Rechercher",
    filter: "Filtrer",
    loading: "Chargement...",
    error: "Erreur",
    success: "Succès",
    confirm: "Confirmer",
    back: "Retour",
    next: "Suivant",
    submit: "Soumettre",
    selectOption: "Sélectionner une option",
    required: "Requis",
    euros: "€",
  }
};

export const useTranslation = (language = 'en') => {
  const t = (key) => {
    return translations[language]?.[key] || translations['en']?.[key] || key;
  };
  return { t };
};
